<ng-template #content>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{title}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modalRef.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <label *ngIf="type ==='text'">
      <div class="container-fluid">
        <div class="row">
          <div class="col-4">
            {{text}}
          </div>
          <div class="col-8">
            <input type="text" formControlName="newValueText">
          </div>
        </div>
      </div>
    </label>
    <div *ngIf="type ==='select'">
      <div class="container-fluid">
        <div class="row">
          <div class="col-4">
            {{text}}
          </div>
          <div class="col-8">
            <ng-select [items]="possibleValuesSelect" [bindLabel]="'value'" [bindValue]="'key'"
              [(ngModel)]="newValueSelect" [virtualScroll]='true' notFoundText="---" [searchable]='false'
              [clearable]='false' placeholder='---'>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="cancel" type="button" class="btn btn-lg primary"
      (click)="modalRef.dismiss('Cross click')">{{cancel}}</button>
    <button type="button" class="btn btn-lg primary" (click)="modalRef.close('Save click')">{{submit}}</button>
  </div>
</ng-template>

<a (click)="open(content)">
  <svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title i18n="edit-value|@@edit">Modifier</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
      <g id="UI-Rapport" transform="translate(-732.000000, -206.000000)" fill="#162C4B" fill-rule="nonzero">
        <g id="Header-Small" transform="translate(165.000000, 153.000000)">
          <g id="Group-Copy-3" transform="translate(452.000000, 24.000000)">
            <g id="pen-01" transform="translate(115.000000, 29.000000)">
              <path
                d="M6.48,3 L0.24,9.24 C0.08,9.4 0,9.56 0,9.8 L0,12.2 C0,12.68 0.32,13 0.8,13 L3.2,13 C3.44,13 3.6,12.92 3.76,12.76 L10,6.52 L6.48,3 Z"
                id="Path"></path>
              <path
                d="M12.7692308,2.53846154 L10.4615385,0.230769231 C10.1538462,-0.0769230769 9.69230769,-0.0769230769 9.38461538,0.230769231 L8,1.61538462 L11.3846154,5 L12.7692308,3.61538462 C13.0769231,3.30769231 13.0769231,2.84615385 12.7692308,2.53846154 Z"
                id="Path"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</a>


// WEBPACK FOOTER //
// ./src/app/edit-value-modal/edit-value-modal.component.html